import { deleteUserInviteByHash } from "../../api/userInviteService";

export const useDeleteUserInviteByHash = (successCallback) => {
    const remove = async (hash) => {
        try {
        await deleteUserInviteByHash(hash);
            if (successCallback) successCallback();
        } catch (error) {
            console.error("Failed to delete user invite:", error);
            throw error;
        }
    };

    return { remove };
};